import UserCoursesBlankHeaderImageSvg from 'src/assets/images/user-courses-blank-header-image.svg';
import styled from 'styled-components';

export const UserCoursesBlankHeaderImage = styled(UserCoursesBlankHeaderImageSvg)`
  width: 100%;
`;
